import React, { useState } from "react";
import logoImg from '../logo.svg';
import {Icon} from 'react-icons-kit';
import {menu} from 'react-icons-kit/feather/menu';
//import {arrowLeft} from 'react-icons-kit/feather/arrowLeft';


function CustomerManagement() {
    return (
        <div className="dashboard-content">
        <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div>
        <div className="body-cart tab-content dasContent p-4 bg-white rounded">
          <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
              <h1 className="heading h4 mb-0 fw-bold">Customer Management</h1>
              {/* <div className="d-inline-flex gap-2">
                  <NavLink to="#" className="btn btn-primary">View All</NavLink>
                  <NavLink to="#" className="btn btn-outline-primary"><Icon className="arrowLeft" icon={arrowLeft} size={18}/> Back</NavLink>
              </div> */}
          </div>
          <div role="tabpanel" className="personal-info tab-pane active" id="pi">
            <h4 className="text-primary h6 fw-bold mb-3">Customer information</h4>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating">
                    <input type="text" className="form-control" id="firstName" placeholder="First Name" />
                    <label htmlFor="firstName">First Name</label>
                </div>
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating">
                    <input type="text" className="form-control" id="lastName" placeholder="First Name" />
                    <label htmlFor="lastName">Last Name</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating">
                    <input type="text" className="form-control" id="phone" placeholder="Phone" />
                    <label htmlFor="phone">Phone</label>
                </div>
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating">
                    <input type="text" className="form-control" id="email" placeholder="Email" />
                    <label htmlFor="email">Email</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="roleName" aria-label="Role Name">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="roleName">Role Name</label>
                  </div>
              </div>              
            </div>
          </div>
          <hr/>
          <div role="tabpanel" className="address-info">
            <h4 className="text-primary h6 fw-bold mb-4">Address Information</h4>
            <div className="add-new-address-section">
              <div className="row">
                <div className="form-group col-sm-12 col-lg-12 mb-3">
                  <div className="form-floating">
                      <textarea className="form-control" placeholder="Billing Address" id="billingAddress" style={{height: 120 + 'px'}}></textarea>
                      <label htmlFor="billingAddress">Billing Address</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="billingCountry" aria-label="Billing Country">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="billingCountry">Billing Country</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <input type="text" className="form-control" id="billingZipCode" placeholder="Billing Zip Code" />
                      <label htmlFor="billingZipCode">Billing Zip Code</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="bCounty" aria-label="Billing County">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="bCounty">Billing County</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="bCountySub" aria-label="Billing County Sub">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="bCountySub">Billing County</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div role="tabpanel" className="other-info" >
            <h4 className="text-primary h6 fw-bold mb-4">Other Information</h4>
            <div className="add-new-address-section">
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <select className="form-select" id="status" aria-label="Status">
                          <option defaultValue>Select</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                      </select>
                      <label htmlFor="status">Status</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <input type="file" className="form-control" id="profilePhoto" placeholder="Profile Photo" />
                      <label htmlFor="profilePhoto">Profile Photo</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                    <label className="form-check-label" htmlFor="inlineRadio1">Verified</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                    <label className="form-check-label" htmlFor="inlineRadio2">Unerified</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div role="tabpanel" className="password-info">
            <h4 className="text-primary h6 fw-bold mb-4">Password Information</h4>
            <div className="add-new-address-section">
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating">
                      <input type="password" className="form-control" id="password" placeholder="Password" />
                      <label htmlFor="password">Password</label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating input-group mb-4">
                    <div className="form-floating">
                        <input type="password" className="form-control" id="confirmPassword" placeholder="Confirm Password" />
                        <label htmlFor="confirmPassword">Confirm Password</label>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3 d-flex justify-content-end">
                <button type="submit" className="btn btn-danger btn-lg save-btn text-uppercase">Descard</button> &nbsp;
                <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase">Save</button>
              </div>
            </div>
        </div>
    
      </div>
    );
  }
export default CustomerManagement;
